import { render, staticRenderFns } from "./moduleNine.vue?vue&type=template&id=11b8a20e&scoped=true&"
import script from "./moduleNine.vue?vue&type=script&lang=js&"
export * from "./moduleNine.vue?vue&type=script&lang=js&"
import style0 from "./moduleNine.vue?vue&type=style&index=0&id=11b8a20e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b8a20e",
  null
  
)

export default component.exports